var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tit-wrap', _vm._b({
    staticClass: "tit-wrap--top-line tit-wrap--txtadd-sm"
  }, 'tit-wrap', _vm.$attrs, false), [_c('v-divider', {
    staticClass: "primary border-2 border-md-4 mb-12px mb-md-16px",
    attrs: {
      "data-aos": "fade-down"
    }
  }), _vm._t("default")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }